import { Box, Typography } from '@mui/material';
import { createColumnHelper } from '@tanstack/react-table';
import { PeopleIcon } from '../../../icons';
import { BenefitSet } from '@pxtra-client-lib-legacy/gen';
import { BenefitCell } from './cells/benefit-cell';
import { ActionsCellBenefitSets } from './cells/actions-cell';
import { allBenefits } from '../../../../stores/benefitsStore';
import { BenefitSetNameCell } from './cells/benefit-set-cell';
import { LastChangedCell } from './cells/last-changed-cell';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { de, enUS } from 'date-fns/locale';

const columnHelper = createColumnHelper<BenefitSet>();

export const createBenefitSetColumns = () => {
  const { t, i18n } = useTranslation();
  return [
    columnHelper.accessor('name', {
      header: t('benefitSet:benefitSet_one'),
      cell: ({ row }) => {
        const { name, name_de, name_en } = row.original;
        const localizedSetName =
          i18n.language === 'en' && name_en
            ? name_en
            : i18n.language === 'de' && name_de
              ? name_de
              : (name ?? '');

        return <BenefitSetNameCell name={localizedSetName} />;
      },
      enableColumnFilter: false
    }),

    columnHelper.accessor('employee_count', {
      header: `${t('common:EMPLOYEES')} (${format(new Date(), 'MMM', {
        locale: i18n.language === 'de' ? de : enUS
      })})`,
      cell: ({ row }) => (
        <Box className="flex items-center gap-2">
          <PeopleIcon className="[&_path]:fill-none" />
          <Typography className="font-medium">{row.original.employee_count}</Typography>
        </Box>
      ),
      enableColumnFilter: false
    }),
    columnHelper.accessor('enabled_benefits', {
      header: t('common:BENEFITS'),
      cell: ({ row }) => <BenefitCell row={row.original} />,
      meta: {
        filterVariant: 'select',
        filterOptions:
          allBenefits.map((benefit) => ({
            value: benefit,
            text: t(`benefits:${benefit}`)
          })) || []
      },
      filterFn: (row, columnId, filterValue) => {
        if (!filterValue || filterValue.length === 0) return true;

        return row.original.enabled_benefits?.includes(filterValue) ?? true;
      }
    }),
    columnHelper.accessor('last_changed_at', {
      header: t('benefitSet:lastChanged'),
      cell: ({ row }) => <LastChangedCell row={row.original} />,

      enableColumnFilter: false
    }),
    columnHelper.display({
      id: 'actions',
      header: t('common:ACTIONS'),
      cell: (info) => <ActionsCellBenefitSets info={info} />
    })
  ];
};
